var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings.enable_newsletter_form)?_c('div',{class:[_vm.sliceWidth === 'full-width' && _vm.backgroundColor]},[_c('newsletter-form',{attrs:{"data":_vm.data}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }